import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function checkAccountCreditList(params) {
  return authPost(`${baseUrl}/Agent9.ashx`, params);
}
